import { px, useMantineTheme } from "@mantine/core";
import { useElementSize, useMediaQuery } from "@mantine/hooks";

export function useIsMobile() {
  const { breakpoints } = useMantineTheme();
  const isMini = useMediaQuery(`(max-width: ${breakpoints.xs})`);
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.sm})`);
  const isTablet = useMediaQuery(`(max-width: ${breakpoints.md})`);
  const isDesktop = useMediaQuery(`(max-width: ${breakpoints.lg})`);
  return { isMini, isMobile, isTablet, isDesktop };
}

export function useIsMobileContainer() {
  const { ref, width } = useElementSize();
  const { breakpoints } = useMantineTheme();
  const isMiniContainer = width < (px(breakpoints.xs) as number);
  const isMobileContainer = width < (px(breakpoints.sm) as number);
  const isTabletContainer = width < (px(breakpoints.md) as number);
  const isDesktopContainer = width < (px(breakpoints.lg) as number);
  return { ref, isMiniContainer, isMobileContainer, isTabletContainer, isDesktopContainer };
}
